import type { CSSProperties } from "react";

import "component/loader/styles.scss";

interface LoaderProps {
  // Lit dot colour; defaults to white. Any CSS colour.
  color?: string;
  // Dot diameter in px; the spacing between dots scales with it. Defaults to 15.
  size?: number;
  className?: string;
  // Announced to screen readers; defaults to "Loading".
  label?: string;
}

// A small animated "loading" indicator for places that wait on something a skeleton can't
// represent (a button action, an inline fetch). Standalone like the skeletons: no Redux, i18n or
// store imports, so it is safe in the main bundle. Pass `label` for a translated announcement.
export function Loader({ color, size, className, label = "Loading" }: LoaderProps) {
  const style = {
    ...(color ? { "--loader-color": color } : {}),
    ...(size ? { "--loader-size": `${size}px` } : {}),
  } as CSSProperties;

  return <div className={`loader ${className ?? ""}`.trim()} style={style} role="status" aria-label={label} />;
}

export default Loader;
